import { LayerProps } from "react-map-gl/maplibre";
import { HeatMapConfigs } from "~map-style-utils/types/__generated/gql/graphql";

export const getHeatMapStyle = (configs: HeatMapConfigs): LayerProps[] => {
	const { basic } = configs;

	const styles: LayerProps[] = [];

	styles.push({
		id: "heatmap",
		type: "heatmap",
		paint: {
			"heatmap-weight": 1,
			"heatmap-intensity": ["interpolate", ["linear"], ["zoom"], 0, 1, 9, 3],
			"heatmap-color": [
				"interpolate",
				["linear"],
				["heatmap-density"],
				0,
				"rgba(50, 50, 255, 0)",
				0.2,
				"rgb(0, 204, 255)",
				0.4,
				"rgb(128, 255, 128)",
				0.6,
				"rgb(255, 255, 102)",
				0.8,
				"rgb(255, 128, 0)",
				1,
				"rgb(204, 0, 0)",
			],

			"heatmap-radius": basic?.radius ?? 20,
			"heatmap-opacity": basic?.opacity ?? 1,
		},
	});

	return styles;

	// const { basic } = configs;

	// return {
	// 	type: "symbol",
	// 	fill: {
	// 		type: "heatmap",
	// paint: {
	// 	"heatmap-weight": 1,
	// 	"heatmap-intensity": ["interpolate", ["linear"], ["zoom"], 0, 1, 9, 3],
	// 	"heatmap-color": [
	// 		"interpolate",
	// 		["linear"],
	// 		["heatmap-density"],
	// 		0,
	// 		"rgba(50, 50, 255, 0)",
	// 		0.2,
	// 		"rgb(0, 204, 255)",
	// 		0.4,
	// 		"rgb(128, 255, 128)",
	// 		0.6,
	// 		"rgb(255, 255, 102)",
	// 		0.8,
	// 		"rgb(255, 128, 0)",
	// 		1,
	// 		"rgb(204, 0, 0)",
	// 	],

	// 	"heatmap-radius": basic?.radius ?? 20,
	// 	"heatmap-opacity": basic?.opacity ?? 1,
	// },
	// 	},
	// };
};
